var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "ReactiveModal",
        {
          staticClass: "modal_plan-task plan-task",
          class: { "iframe-view": _vm.iframeView },
          attrs: {
            id: "task-modal",
            title: this.task.name,
            "modal-size": "custom",
          },
          on: {
            close: function ($event) {
              return _vm.$emit("close")
            },
          },
          scopedSlots: _vm._u(
            [
              _vm.hideHeaderBtn
                ? {
                    key: "left-actions",
                    fn: function () {
                      return [_c("div")]
                    },
                    proxy: true,
                  }
                : {
                    key: "left-actions",
                    fn: function () {
                      return [
                        _c("div", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                type: "button",
                                "data-dismiss": "modal",
                              },
                            },
                            [_vm._v("Закрыть")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("openTasks")
                                },
                              },
                            },
                            [_vm._v("Все задачи")]
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
              {
                key: "actions",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between" },
                      [
                        _vm.isAccessAllow
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary mr-auto",
                                on: {
                                  click: function ($event) {
                                    _vm.confirmContext = true
                                  },
                                },
                              },
                              [_vm._v("Удалить")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hideHeaderBtn
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary ml-auto",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("openTasks")
                                  },
                                },
                              },
                              [_vm._v("Все задачи")]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        [
          _vm._v(" "),
          _vm._v(" "),
          _vm.task.id
            ? _c("div", { staticClass: "task" }, [
                _c("div", { staticClass: "task__row task-summary" }, [
                  _c("div", { staticClass: "task__col" }, [
                    _c(
                      "h3",
                      { staticClass: "task-summary__title" },
                      [
                        !_vm.openEditName
                          ? _c(
                              "span",
                              { staticClass: "text-icon" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.task.name) +
                                    "\n                            "
                                ),
                                _vm.isAccessAllow
                                  ? _c("Icon", {
                                      attrs: { id: "edit" },
                                      on: {
                                        click: function ($event) {
                                          _vm.openEditName = true
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _c("EditText", {
                              on: {
                                apply: function ($event) {
                                  _vm.openEditName = false
                                  _vm.updateTask()
                                },
                                cancel: function ($event) {
                                  _vm.openEditName = false
                                  _vm.editableTask.set("name", _vm.task.name)
                                },
                              },
                              model: {
                                value: _vm.editableTask.name,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editableTask,
                                    "name",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "editableTask.name",
                              },
                            }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "task-prop" }, [
                      _c("strong", [_vm._v("URL:")]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "task-prop__value ellipsis",
                          attrs: { href: _vm.task.url, target: "_blank" },
                        },
                        [_vm._v(_vm._s(_vm.task.url))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "task-prop" }, [
                      _c("strong", [_vm._v("Домен:")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "task-prop__value ellipsis" }, [
                        _vm._v(_vm._s(_vm.task.domain)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "task-prop" }, [
                      _c("strong", [_vm._v("Мониторинг:")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "task-prop__value" }, [
                        _vm._v(_vm._s(_vm.runLabel)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "task-prop" }, [
                      _c("strong", [_vm._v("Постановщик задачи:")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "task-prop__value" }, [
                        _vm._v(
                          _vm._s(_vm.ownerMyser.lastname) +
                            " " +
                            _vm._s(_vm.ownerMyser.firstname)
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "task__col" },
                    [
                      _c("h3", { staticClass: "task-summary__title" }),
                      _vm._v(" "),
                      _c("PlanPropDate", {
                        staticClass: "task-prop_date-start",
                        attrs: { label: "Старт:", value: _vm.task.dateStart },
                        on: {
                          update: (v) =>
                            _vm.editableTask.set("dateStart", v) &&
                            _vm.updateTask(true),
                        },
                      }),
                      _vm._v(" "),
                      _c("PlanPropDate", {
                        staticClass: "task-prop_date-finish",
                        attrs: {
                          label: "Финиш:",
                          value: _vm.task.datePlanFinish,
                          disabled: "2" !== _vm.task.status,
                        },
                        on: {
                          update: (v) =>
                            _vm.editableTask.set("datePlanFinish", v) &&
                            _vm.updateTask(true),
                        },
                      }),
                      _vm._v(" "),
                      _vm.isAccessAllow
                        ? _c("Status", {
                            attrs: {
                              list: _vm.taskStatuses,
                              active: _vm.task.status,
                            },
                            on: {
                              update: (v) =>
                                _vm.editableTask.set("status", v) &&
                                _vm.updateTask(true),
                            },
                          })
                        : _c(
                            "div",
                            { staticClass: "task-prop task-prop_status" },
                            [
                              _c("strong", { staticClass: "mr-2" }, [
                                _vm._v("Статус: "),
                              ]),
                              _vm._v(
                                _vm._s(
                                  _vm.taskStatuses.find(
                                    (s) => +s.id === +_vm.task.status
                                  )?.name || "не выбран"
                                ) + "\n                    "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "task__col" },
                    [
                      _c("h3", { staticClass: "task-summary__title" }),
                      _vm._v(" "),
                      _c("Priority", {
                        attrs: {
                          disable: !_vm.isAccessAllow,
                          value: _vm.task.priority,
                        },
                        on: {
                          update: (v) =>
                            _vm.editableTask.set("priority", v) &&
                            _vm.updateTask(),
                        },
                      }),
                      _vm._v(" "),
                      _c("Tags", {
                        attrs: {
                          disabled: !_vm.isAccessAllow,
                          "tags-only": !_vm.isAccessAllow,
                          tags: _vm.task.tags,
                        },
                        on: {
                          update: (v) =>
                            _vm.editableTask.set("tags", v) && _vm.updateTask(),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "task__col" },
                    [
                      _c("h3", { staticClass: "task-summary__title" }, [
                        _vm._v("Журнал изменений"),
                      ]),
                      _vm._v(" "),
                      _c("TaskLogs", { attrs: { urlTaskId: _vm.urlTaskId } }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "task-detail" }, [
                  _c("h3", { staticClass: "task-summary__title" }, [
                    _vm._v("Список подзадач"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "task-detail__row" },
                    [
                      _c("Subtasks", {
                        staticClass: "task-detail__streams",
                        attrs: {
                          "is-access-allow": _vm.isAccessAllow,
                          urlTaskId: _vm.urlTaskId,
                          service: _vm.service,
                          runId: _vm.runId,
                          urlId: _vm.urlId,
                        },
                      }),
                      _vm._v(" "),
                      _vm.selectedStream &&
                      Object.keys(_vm.selectedStream).length
                        ? [
                            _c("Subtask", {
                              staticClass: "task-detail__stream",
                              attrs: { "is-access-allow": _vm.isAccessAllow },
                            }),
                            _vm._v(" "),
                            _c("StreamComments", {
                              staticClass: "task-detail__comments",
                              attrs: { "is-access-allow": _vm.isAccessAllow },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.confirmContext
        ? _c(
            "ReactiveConfirm",
            {
              attrs: {
                title: "Подтверждение действия",
                confirmText: "Удалить",
              },
              on: {
                close: function ($event) {
                  _vm.confirmContext = false
                },
                confirm: _vm.deleteTask,
              },
            },
            [_c("p", [_vm._v("Действительно удалить?")])]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }